import { AccountForm } from "@/features/staff/registration/account-form"
import { RegistrationHeader } from "@/features/staff/registration/registration-header"
import { RegistrationIntro } from "@/features/staff/registration/registration-intro"
import { RegistrationSupport } from "@/features/staff/registration/registration-support"

/**
 * Staff sign-up — step 1 of the two the controller actually runs. Creating the
 * account redirects straight to `new_staff_location_path`, so the screen says
 * so instead of presenting itself as the finish line.
 *
 * DOM order is intro → form → support, which is the right reading order on a
 * phone. On `lg` the grid puts the form in its own column beside the two prose
 * blocks; nothing is duplicated or hidden per breakpoint.
 */
export default function StaffRegistrationsNew() {
  return (
    <div className="flex min-h-svh flex-col bg-background">
      <RegistrationHeader />

      <main className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-x-14 gap-y-8 px-4 pb-16 pt-10 lg:grid-cols-[minmax(0,1fr)_420px] lg:pt-14">
        <RegistrationIntro className="lg:col-start-1 lg:row-start-1" />
        <AccountForm className="self-start lg:col-start-2 lg:row-span-2 lg:row-start-1" />
        <RegistrationSupport className="lg:col-start-1 lg:row-start-2" />
      </main>
    </div>
  )
}
